import React from 'react';
import PropTypes from 'prop-types';

import IconStarFill from '../svg/IconStarFill';
import IconStarEmpty from '../svg/IconStarEmpty';

function ButtonFavorite({ size = 24, color = `white`, active = false, onClick, className, style }) {
  return (
    <div className={className} style={{cursor: `pointer`, ...style}} onClick={onClick}>
      { active
        ? <IconStarFill size={size} color={color} />
        : <IconStarEmpty size={size} color={color} />
      }
    </div>
  )
}

ButtonFavorite.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
}

export default ButtonFavorite;
